var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8125 12.5625H15.1875M8.8125 5.4375H15.1875M4.6875 7.3125V3.5625L2.8125 4.875M3 11.1989C3 11.1989 3.5428 10.6875 4.20665 10.6875C4.8705 10.6875 5.40865 11.1539 5.40865 11.7292C5.40865 13.0789 2.8125 13.3125 2.8125 14.4375H5.625",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberedList);
export default __webpack_public_path__ + "static/media/numbered-list.2995f6bba9d1a8c8de14c186e5ffc1b6.svg";
export { ForwardRef as ReactComponent };